var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.247-861.506a9 9 0 0 1-3.606-.728 9.339 9.339 0 0 1-2.936-1.977 9.338 9.338 0 0 1-1.977-2.936 9 9 0 0 1-.728-3.606 9 9 0 0 1 .728-3.606A9.338 9.338 0 0 1 82.7-877.3a9.339 9.339 0 0 1 2.936-1.977 9 9 0 0 1 3.611-.723 9 9 0 0 1 3.606.728 9.339 9.339 0 0 1 2.936 1.977 9.338 9.338 0 0 1 1.977 2.936 9 9 0 0 1 .728 3.606 9 9 0 0 1-.728 3.606 9.338 9.338 0 0 1-1.977 2.936 9.339 9.339 0 0 1-2.936 1.977 9 9 0 0 1-3.606.728zm0-1.849a7.225 7.225 0 0 0 2.4-.4 7.353 7.353 0 0 0 2.127-1.167l-10.353-10.362a7.352 7.352 0 0 0-1.167 2.127 7.225 7.225 0 0 0-.4 2.4A7.14 7.14 0 0 0 84-865.505a7.14 7.14 0 0 0 5.247 2.15zm5.826-2.867a7.351 7.351 0 0 0 1.167-2.127 7.225 7.225 0 0 0 .4-2.4A7.14 7.14 0 0 0 94.495-876a7.139 7.139 0 0 0-5.248-2.15 7.225 7.225 0 0 0-2.4.4 7.353 7.353 0 0 0-2.127 1.167z",
    transform: "translate(-77.356 882.645)",
    fill: "#34384b",
    stroke: "#34384b",
    "data-name": "Group 13377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoid);
export default __webpack_public_path__ + "static/media/void.eb59d6ececb233f5a8e729bfa70d47b6.svg";
export { ForwardRef as ReactComponent };